import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "picker"];
  connect() {
    this.inputTarget.addEventListener("change", () => {
      if (this.inputTarget.checked){
        this.pickerTarget.setAttribute("tabindex", "0");
      }
    });
  }

  hide() {
    this.inputTarget.checked = false; // Unchecks the <input> element, hiding the modal
    this.pickerTarget.setAttribute("tabindex", "-1");
    this.inputTarget.focus();
  }
}
